import { render, staticRenderFns } from "./ManageMessageTemplate.vue?vue&type=template&id=08401aac&scoped=true&lang=pug&"
import script from "./ManageMessageTemplate.vue?vue&type=script&lang=js&"
export * from "./ManageMessageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08401aac",
  null
  
)

export default component.exports